import { render, staticRenderFns } from "./KegiatanRadiologi.vue?vue&type=template&id=3c72c70a"
import script from "./KegiatanRadiologi.vue?vue&type=script&lang=js"
export * from "./KegiatanRadiologi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c72c70a')) {
      api.createRecord('3c72c70a', component.options)
    } else {
      api.reload('3c72c70a', component.options)
    }
    module.hot.accept("./KegiatanRadiologi.vue?vue&type=template&id=3c72c70a", function () {
      api.rerender('3c72c70a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanRadiologi.vue"
export default component.exports